import { Component, Input } from '@angular/core';
import { NullLists } from '../../services/null-lists.service';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-data-jumbotron',
    template: `
        <div class="content-column">
            <ol>
                <li *ngFor="let item of items || nullLists.get(7)" [ngClass]="item?.status ? [item!.status] : ['normal']">
                    <ng-container *ngIf="item && item.value !== undefined; else placeholder">
                        <mat-icon>{{ item.icon }}</mat-icon>
                        <div class="text">
                            <div class="value">
                                <ng-container *ngIf="item.value !== null; else valueNA">
                                    <ng-container *ngIf="item.value.constructor.name !== 'Array'; else multipleValues">
                                        {{ item.value }}
                                    </ng-container>
                                    <ng-template #multipleValues>
                                        <ul>
                                            <li *ngFor="let value of item.value">{{ value }}</li>
                                        </ul>
                                    </ng-template>
                                </ng-container>
                                <ng-template #valueNA><app-na></app-na></ng-template>
                            </div>
                            <div class="label">{{ item.label }}</div>
                        </div>
                    </ng-container>
                </li>
            </ol>
            <ng-template #placeholder>
                <div class="icon-placeholder"></div>
                <div class="text">
                    <div class="value">
                        <egov-text-ui-placeholder [length]="30" [lengthThreshold]="20"></egov-text-ui-placeholder>
                    </div>
                    <div class="label"><egov-text-ui-placeholder [length]="12" [lengthThreshold]="5"></egov-text-ui-placeholder></div>
                </div>
            </ng-template>
        </div>
    `,
    styleUrls: ['./data-jumbotron.component.scss'],
})
export class DataJumbotronComponent
{
    constructor
    (
        // Template dependencies

        protected readonly nullLists: NullLists
    )
    {}

    @Input() protected items?: JumbotronItem[];
}

export interface JumbotronItem
{
    icon: string
    label: string
    value?: string | string[]
    html?: boolean
    status?: JumbotronItemStatus
}

export enum JumbotronItemStatus
{
    NORMAL = 'normal',
    GOOD = 'good',
    WARNING = 'warning',
    BAD = 'bad',
}
